import React, { useState } from 'react';
import moment from 'moment';
import { useField } from 'formik';

import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const FieldDayRangePicker = ({
  className = '',
  ...props
}) => {
  const [selecting, setSelecting] = useState(null);
  const [, { value }, { setTouched, setValue }] = useField(props);
  const from = (value || [])[0];
  const to = (value || []).slice(-1)[0];

  return (
    <div>
      <div className={`
        ${className}
        h-auto w-auto d-inline-block pt-3
      `}>
        <DayPicker
          initialMonth={
            value?.[0] || new Date()
          }
          selectedDays={
            selecting ? [selecting] : [from, { from, to }]
          }
          modifiers={{
            start: selecting || from,
            end: selecting ? undefined : to,
          }}
          onDayClick={(date) => {
            const d = moment(date).startOf('d').toDate();

            if (selecting) {
              const [f, t] = [selecting, d].sort((a, b) => a - b);

              setTouched();
              setSelecting(null);
              setValue([f, t]);
            } else {
              setSelecting(d);
            }
          }}
        />
      </div>
    </div>
  );
};

export default FieldDayRangePicker;
